<template>
  <v-dialog v-model="dialog" max-width="700" style="overflow: hidden !important;">
    <v-card>
      <v-card-title>
        {{processType === "new" ? "Yeni Proje Ekle" :  "Proje Düzenle"}}
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      @input="$v.startDate.$touch()"
                      @blur="$v.startDate.$touch()"
                      :error-messages="
                  validationMessages($v.startDate, 'Başlangıç tarihi')
                "
                      :value="formattedDate(startDate)"
                      label="Başlangıç Tarihi"
                      prepend-inner-icon="mdi-calendar"
                      filled
                      solo
                      readonly
                      :disabled="isProjectApproved"
                      dense
                      clearable
                      @click:clear="startDate = null"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="startDate"
                    locale="tr"
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="col-lg-6">
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      @input="$v.endDate.$touch()"
                      @blur="$v.endDate.$touch()"
                      :error-messages="
                  validationMessages($v.endDate, 'Bitiş tarihi')
                "
                      :value="formattedDate(endDate)"
                      label="Bitiş Tarihi"
                      prepend-inner-icon="mdi-calendar"
                      :disabled="isProjectApproved"
                      readonly
                      solo
                      filled
                      dense
                      clearable
                      @click:clear="endDate = null"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="endDate"
                    locale="tr"
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  @input="$v.name.$touch()" @blur="$v.name.$touch()"
                  :error-messages=" validationMessages($v.name, 'Proje İsmi') "
                  v-model="name"
                  label="Proje İsmi"
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
              >
              </v-text-field>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  @input="$v.companyName.$touch()" @blur="$v.companyName.$touch()"
                  :error-messages=" validationMessages($v.companyName, 'Şirket') "
                  v-model="companyName"
                  label="Şirket"
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
              >
              </v-text-field>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  @input="$v.authorizedName.$touch()" @blur="$v.authorizedName.$touch()"
                  :error-messages=" validationMessages($v.authorizedName, 'Yetkili') "
                  v-model="authorizedName"
                  label="Yetkili"
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
              >
              </v-text-field>
            </div>
            <div class="col-lg-6">
              <v-select
                  @input="$v.projectType.$touch()" @blur="$v.projectType.$touch()"
                  :error-messages=" validationMessages($v.projectType, 'Proje Tipi') "
                  v-model="projectType"
                  label="Proje Tipi"
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
                  :items="[
                      {value: 'Hastane', text: 'Hastane'},
                      {value: 'İş Merkezi', text: 'İş Merkezi'},
                      {value: 'Konut', text: 'Konut'},
                      {value: 'Ofis', text: 'Ofis'},
                      {value: 'Otel', text: 'Otel'},
                      {value: 'Ticari Bina', text: 'Ticari Bina'},
                      {value: 'Villa', text: 'Villa'},
                      {value: 'Yat', text: 'Yat'}
                  ]"
              >
              </v-select>
            </div>
            <div class="col-lg-12">
              <v-text-field
                  v-model="architecturalCompanyName"
                  label="Mimari Firma"
                  placeholder=""
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
              >
              </v-text-field>
            </div>
            <div class="col-lg-12">
              <v-text-field
                  v-model="electricalContractingCompany"
                  label="Elektrik Taahhüt"
                  placeholder=""
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
              >
              </v-text-field>
            </div>
            <div class="col-lg-3">
              <v-text-field
                  v-model="companyCity"
                  label="Şehir"
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
              >
              </v-text-field>
            </div>
            <div class="col-lg-3">
              <v-text-field
                  v-model="companyTown"
                  label="İlçe"
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
              >
              </v-text-field>
            </div>
            <div class="col-lg-6">
              <v-textarea
                  @input="$v.description.$touch()" @blur="$v.description.$touch()"
                  :error-messages=" validationMessages($v.description, 'Açıklama') "
                  v-model="description"
                  rows="3"
                  label="Açıklama"
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
              >
              </v-textarea>
            </div>
            <div class="col-lg-6">
              <v-textarea
                  v-model="companyAddress"
                  rows="3"
                  label="Adres"
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
              >
              </v-textarea>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  @input="$v.phoneNumber.$touch()" @blur="$v.phoneNumber.$touch()"
                  :error-messages=" validationMessages($v.phoneNumber, 'Telefon Numarası') "
                  v-model="phoneNumber"
                  label="Telefon Numarası"
                  placeholder="5xxxxxxxxx"
                  dense
                  filled
                  solo
                  clearable
                  :disabled="isProjectApproved"
              >
              </v-text-field>
            </div>
            <div class="col-lg-6">
              <v-switch
                  class="mt-1" v-model="isDemo" flat inset label="Demo Proje" :disabled="isProjectApproved"></v-switch>
            </div>
          </div>
        </div>
        <hr/>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn small class="me-1" color="secondary" @click="closeDialog()"
          >İptal Et
          </v-btn
          >
          <v-btn small color="success" @click="saveProject"
          >Onaya Gönder
          </v-btn
          >
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {formattedDate} from "@/momentHelper";
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {validationMessages} from "@/validationMessages";
import {mapActions, mapState} from "vuex";
import {showProcessErrorMessage} from "@/state/alertHelpers";


export default {
  mixins: [validationMixin],
  // validations: {
  //   startDate: {required},
  //   endDate: {required},
  //   name: {required},
  //   companyName: {required},
  //   authorizedName: {required},
  //   projectType: {required},
  //   address: {required},
  //   phoneNumber: {required},
  //   description: {required},
  // },
  validations() {
    return {
      startDate: {required},
      endDate: {required},
      name: {required},
      companyName: {required},
      authorizedName: {required},
      projectType: {required},
      phoneNumber: {required},
      description: {required},
    };
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    processType: {
      type: String,
      default: "new",
    },
    projectId: {
      type: Object,
      default: () => ({
        id: null,
        userData: null,
        dialog: false,
        selectedId: null,
        startDate: null,
        endDate: null,
        name: null,
        companyName: null,
        projectType: null,
        phoneNumber: null,
        authorizedName: null,
        description: null,
        currentCode: null,
        isDemo: false,
        companyCity: null,
        companyTown: null,
        companyAddress: null,
        architecturalCompanyName: null,
        electricalContractingCompany: null
      }),
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("cart", ["current"]),
    isProjectApproved() {
      if (this.projectId) return this.projectId.status === 2; else return false;
    }

  },
  data() {
    return {
      userData: null,
      dialog: false,
      selectedId: null,
      startDate: null,
      endDate: null,
      name: null,
      companyName: null,
      projectType: null,
      phoneNumber: null,
      authorizedName: null,
      description: null,
      currentCode: null,
      isDemo: false,
      companyCity: null,
      companyTown: null,
      companyAddress: null,
      emitted: false,
      architecturalCompanyName: null,
      electricalContractingCompany: null

    };
  },
  methods: {
    ...mapActions("current", ["fetchSingleCurrent"]),
    ...mapActions("project", ["projectAdd", "fetchSingleProject", "projectUpdate"]),
    validationMessages,
    formattedDate,
    async _addProject() {
      await this.projectAdd({
        params: {
          userId: this.user.UserId,
        },
        body: {
          "startDate": this.startDate,
          "endDate": this.endDate,
          "name": this.name,
          "companyName": this.companyName,
          "projectType": this.projectType,
          "phoneNumber": this.phoneNumber,
          "authorizedName": this.authorizedName,
          "description": this.description,
          // "salesPersonCode": this.salesPersonCode,
          "currentCode": this.currentCode,
          "isDemo": this.isDemo,
          "companyCity": this.companyCity,
          "companyTown": this.companyTown,
          "companyAddress": this.companyAddress,
          "architecturalCompanyName": this.architecturalCompanyName,
          "electricalContractingCompany": this.electricalContractingCompany
        },
      });
    },
    async _updateProject() {
      await this.projectUpdate({
        params: {
          userId: this.user.UserId,
        },
        body: {
          "id": this.selectedId,
          "startDate": this.startDate,
          "endDate": this.endDate,
          "name": this.name,
          "companyName": this.companyName,
          "projectType": this.projectType,
          "phoneNumber": this.phoneNumber,
          "authorizedName": this.authorizedName,
          "description": this.description,
          // "salesPersonCode": this.salesPersonCode,
          "currentCode": this.currentCode,
          "isDemo": this.isDemo,
          "companyCity": this.companyCity,
          "companyTown": this.companyTown,
          "companyAddress": this.companyAddress,
          "architecturalCompanyName": this.architecturalCompanyName,
          "electricalContractingCompany": this.architecturalCompanyName
        }
      })
    },
    closeDialog(){
      this.dialog = false;
      this.$v.$reset();
    },
    async saveProject() {
      if (this.current === null) {
        showProcessErrorMessage(({
          title: "İşlem Başarısız",
          text: "Önce Cari Seçmelisiniz.",
        }));
        return;
      }
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.processType === 'new') {
          if (this.user.RoleGroupId === '2' || this.user.RoleGroupId === 2 || this.user.RoleGroupId === '1' || this.user.RoleGroupId === 1) {
            if (!this.current.code) {
              await showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: 'Lütfen Cari Seçin',
              });
            } else {
              // this.salesPersonCode = this.user.SalesPersonCode;
              this.currentCode = this.current.code;
              await this._addProject()
            }
          } else {
            this.userData = await this.fetchSingleCurrent({
              params: {
                currentCode: this.user.ErpCode
              },
            });
            // this.salesPersonCode = this.userData.salesPersonCode;
            this.currentCode = this.user.ErpCode;
            await this._addProject()
          }
        } else {
          await this._updateProject();
        }
        this.emitted = true;
        this.closeDialog();
      }
    },
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
    },

    showDialog: function (newVal) {
      this.dialog = newVal;
    },
    projectId: function (newVal) {
      newVal;
      this.startDate = this.projectId.startDate;
      this.endDate = this.projectId.endDate;
      this.name = this.projectId.name;
      this.companyName = this.projectId.companyName;
      this.projectType = this.projectId.projectType;
      this.phoneNumber = this.projectId.phoneNumber;
      this.authorizedName = this.projectId.authorizedName;
      this.description = this.projectId.description;
      this.salesPersonCode = this.projectId.salesPersonCode;
      this.selectedId = this.projectId.id;
      this.status = this.projectId.status;
      this.isDemo = this.projectId.isDemo;
      this.currentCode = this.projectId.currentCode;
      this.companyCity = this.projectId.companyCity;
      this.companyTown = this.projectId.companyTown;
      this.companyAddress = this.projectId.companyAddress;
      this.architecturalCompanyName = this.projectId.architecturalCompanyName;
      this.electricalContractingCompany = this.projectId.electricalContractingCompany;
    },
  },
};
</script>
